import * as React from 'react'
import loadable from '@loadable/component'
import dynamic from 'next/dynamic'

import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { Button } from '@thg-commerce/gravity-elements'

import { DeliveryInfoWrapper, DeliveryListItem } from './styles'

const SvgIcon = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/SvgIcon'),
  { ssr: true, fallback: <div style={{ width: 24, height: 24 }} /> },
)

interface ProductContent {
  key: string
  value: {
    stringValue: string[]
  }
}

interface DeliveryDetailsProps {
  content: ProductContent[]
  keys?: string[]
  buttonOnClick: () => void
  viewMoreText?: string
}

const DeliveryIcon: React.FC<{
  svgPath: string
  width?: string
  height?: string
  viewBox?: string
}> = ({ svgPath, width = '24px', height = '24px', viewBox = '0 0 24 24' }) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    aria-hidden="true"
  >
    <path d={svgPath} />
  </SvgIcon>
)

export const DeliveryInformation: React.FC<DeliveryDetailsProps> = ({
  content,
  buttonOnClick,
  viewMoreText,
}) => {
  const theme = useTheme()
  const { width, height, viewBox } =
    theme.pageTheme?.deliveryInformation.icons || {}
  return (
    <DeliveryInfoWrapper>
      <ul aria-labelledby="delivery-information-heading">
        {content.slice(0, 5).map((item) => {
          const iconData =
            theme.pageTheme?.deliveryInformation.icons.iconDefinitions[item.key]

          return (
            <DeliveryListItem key={item.key}>
              <span aria-hidden="true">
                {iconData && (
                  <DeliveryIcon
                    svgPath={iconData.svgPath}
                    width={width}
                    height={height}
                    viewBox={viewBox}
                  />
                )}
              </span>
              {item.value.stringValue}
            </DeliveryListItem>
          )
        })}
      </ul>
      <Button ariaLabel={viewMoreText} emphasis="low" onClick={buttonOnClick}>
        {viewMoreText}
      </Button>
    </DeliveryInfoWrapper>
  )
}

export default DeliveryInformation
